import {validateRequired} from "./ValidationFunctions";

const ChooseRatingForm = {
  fields: {
    score: {
      type: 'select',
      label: 'Show all comments for score equal or below',
      value: 'value',
      optionLabel: 'label',
      options: [
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        },
        {
          value: 4,
          label: '4'
        },
        {
          value: 5,
          label: '5'
        },
        {
          value: 6,
          label: '6'
        },
        {
          value: 7,
          label: '7'
        },
      ],
      rules: [validateRequired('Score')]
    },
  }
}

export {
  ChooseRatingForm
}
